import { useAppSelector } from '@/redux/hooks'

type ModalAction = 'insert' | 'delete' | 'update'

interface InsertCommentProps {
  formData: {
    commentCn: string
  }
  nickName?: string
  userNickName?: string
  isAuthenticated: boolean
  handleCommentAction: (action: ModalAction, item?: any) => void
  handleChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void
  isMobile: boolean
}

export const InsertComment: React.FC<InsertCommentProps> = ({
  formData,
  nickName,
  isAuthenticated,
  handleCommentAction,
  handleChange,
  isMobile,
}) => {
  return (
    <>
      {!isMobile ? (
        <div style={{ marginBottom: '10px' }}>
          <div
            style={{
              padding: '10px',
              border: '2px solid #f1f1f1',
              height: 'auto',
              borderRadius: '6px',
              marginBottom: '10px',
            }}
          >
            <div style={{ fontWeight: 'bold' }}>{nickName}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }} />
            <textarea
              id="commentCn"
              name="commentCn"
              placeholder={
                !isAuthenticated
                  ? '댓글을 남기시려면 로그인이 필요해요.'
                  : '댓글을 입력하세요.'
              }
              rows={3}
              maxLength={255}
              disabled={!isAuthenticated}
              value={formData.commentCn}
              onChange={handleChange}
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement
                target.style.height = 'auto' // 높이를 초기화하여 스크롤 높이를 정확히 계산
                target.style.height = `${target.scrollHeight}px` // 내용에 맞게 높이 설정
              }}
              style={{
                width: '100%',
                padding: '10px',
                border: 'none', // 테두리 제거
                outline: 'none', // 포커스 시 테두리 제거
                borderRadius: '4px', // 모서리를 둥글게
                resize: 'none', // 사용자가 크기 조정 불가
                overflow: 'hidden', // 스크롤 숨기기
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                color: '#979797',
                cursor: 'pointer',
              }}
            >
              {isAuthenticated && (
                <div onClick={() => handleCommentAction('insert')}>등록</div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="comments-section">
          <div className="comment-input-section">
            <textarea
              id="commentCn"
              name="commentCn"
              placeholder={
                !isAuthenticated
                  ? '댓글을 남기시려면 로그인이 필요해요.'
                  : '댓글을 입력하세요.'
              }
              rows={3}
              maxLength={255}
              value={formData.commentCn}
              onChange={handleChange}
              // placeholder="댓글을 입력하세요."
              className="comment-input"
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement
                target.style.height = 'auto' // 높이를 초기화하여 스크롤 높이를 정확히 계산
                target.style.height = `${target.scrollHeight}px` // 내용에 맞게 높이 설정
              }}
              disabled={!isAuthenticated}
            />
            {isAuthenticated && (
              <div className="comment-input-footer">
                <button
                  onClick={() => handleCommentAction('insert')}
                  className="comment-submit-button"
                >
                  댓글 작성
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
